import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    color: "transparent.white.80",

    _placeholder: {
      color: "transparent.white.80",
    },
  },
});

const variants = {
  outline: definePartsStyle({
    field: {
      borderColor: "transparent.white.20",
      _hover: {
        borderColor: "transparent.white.40",
      },
      _focus: {
        borderColor: "transparent.white.40",
      },
    },
  }),
  searchBar: definePartsStyle({
    field: {
      fontFamily: "Bricolage Grotesque 24pt",
      fontSize: "lg",
      fontWeight: "500",
      color: "dune.100",
      bg: "transparent",
      border: "none",
      borderRadius: "0",
      px: 3,
      _placeholder: {
        color: "neutral.400",
        fontWeight: "500",
      },
      _hover: {},
      _focusVisible: {
        outline: "none",
        boxShadow: "none",
      },
    },
  }),
};

export const inputTheme = defineMultiStyleConfig({ baseStyle, variants });
